import { jsx as _jsx } from "react/jsx-runtime";
import { Container, Skeleton } from '@emburse/embark-core';
function DataGridLoading() {
    return (_jsx(Container, { disableGutters: true, style: {
            marginTop: '-115px',
            zIndex: 99,
            position: 'relative'
        }, children: Array(10)
            .fill(1)
            .map((item, index) => (_jsx(Skeleton
        // eslint-disable-next-line react/no-array-index-key
        , { height: 80, sx: { marginBottom: '-25px' } }, `${item}${index}`))) }));
}
export default DataGridLoading;
